<template>
  <div class="main">
    <!-- 头部 -->
    <div class="header">
      <span class="tit">顶级合伙人UID</span>
      <!-- {{ topChannelList }} -->
      <el-select filterable remote v-model="value" @change="changeTop" :loading="loading" placeholder="请选择合伙人"
        reserve-keyword :remote-method="remoteMethod" size="mini">
        <el-option v-for="item in filterList" :key="item.topChannelUserId" :label="item.topChannelUserName"
          :value="item.topChannelUserId">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      value: '',
      loading: false,
      options: [],
    };
  },
  computed: {
    ...mapState("topPartner", ["topPartner", "topChannelList"]),
    ...mapGetters("topPartner", ["filterTopPartnerList"]),
    value1() {
      return this.filterTopPartnerList.filter(
        (item) => item.id == this.topPartner
      )[0].channelUserId;
    },
    filterList() {
      return [
        { topChannelUserName: "所有用户", topChannelId: "", topChannelUserId: "" },
        { topChannelUserName: "全部合伙人", topChannelId: 2, topChannelUserId: "2" },
        { topChannelUserName: "散户", topChannelId: 1, topChannelUserId: "1" },
        ...this.topChannelList.map(item => ({ topChannelUserName: item.topChannelUserId, topChannelId: item.topChannelId, topChannelUserId: item.topChannelUserId })),
      ];
    },
  },

  methods: {
    ...mapMutations("topPartner", ["setTopPartner", "setTopChannelList"]),
    ...mapActions("topPartner", ["getTopPartner", "getTopChannelList"]),
    changeTop(e) {
      // console.log("e", e,this.topChannelList);
      this.setTopPartner(e);

      localStorage.setItem("topPartner", e);
      // console.log('this.value',this.value);
      this.$emit("refreshTopPartner");
    },
    remoteMethod(query) {
      // console.log('query',query);
      if (query !== "") {
        this.loading = true;
        this.getTopChannelList({ topChannelUserId: query }).then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.setTopChannelList(res.data);
          } else {
            this.setTopChannelList([]);
          }
        });
      } else {
        this.getTopChannelList({ topChannelUserId: "" }).then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.setTopChannelList(res.data);
          }
        });
      }
    },
  },
  mounted() {
    // this.value=this.filterTopPartnerList.filter(item=>item.id==this.topPartner)[0].channelUserId
    this.getTopChannelList({ topChannelUserId: "" }).then((res) => {
      this.setTopChannelList(res.data);
    });
    // this.value=this.topChannelList?this.topChannelList.filter(item=>item.topChannelId==localStorage.getItem('topPartner'))[0].topChannelUserId:''
  },
};
</script>

<style lang="less" scoped>
.main {
  // border:1px solid red;
  padding: 5px 10px;
  // width:300px;
  margin-left: 20px;
  background: #f5f5f5;
  border-radius: 6px;

  .tit {
    margin-right: 6px;
  }
}
</style>
